import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from "react";
export function AgentSelector({ agents, selected, onChange, disabled }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const current = agents.find((a) => a.name === selected);
    // Close on outside click
    useEffect(() => {
        if (!open)
            return;
        function handleClick(e) {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, [open]);
    return (_jsxs("div", { className: "agent-selector", ref: ref, children: [_jsx("label", { children: "Agent" }), _jsxs("button", { className: "agent-selector-trigger", onClick: () => !disabled && setOpen((o) => !o), disabled: disabled, type: "button", children: [_jsx("span", { className: "agent-selector-name", children: current?.name ?? "Select agent" }), _jsx("span", { className: "agent-selector-chevron", children: open ? "▲" : "▼" })] }), open && (_jsx("div", { className: "agent-selector-dropdown", children: agents.map((a) => (_jsxs("button", { type: "button", className: `agent-selector-option${a.name === selected ? " agent-selector-option--active" : ""}`, onClick: () => {
                        onChange(a.name);
                        setOpen(false);
                    }, children: [_jsx("span", { className: "agent-option-name", children: a.name }), _jsx("span", { className: "agent-option-desc", children: a.description })] }, a.name))) }))] }));
}
//# sourceMappingURL=AgentSelector.js.map